import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { addDays, format } from 'date-fns';
import { AuthService, CustomerService, ProductService, SelectedCustomerService } from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { JeevesSalesCartListRow } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
  selector: 'tylo-delivery-planning-edit-modal',
  templateUrl: './tylo-delivery-planning-edit-modal.component.html',
  styleUrls: ['./tylo-delivery-planning-edit-modal.component.scss']
})
export class TyloDeliveryPlanningEditModalComponent implements OnInit {
  selectedCustomer;
  applyOnOrder;
  minInitialDate;

  constructor(
    public activeModal: NgbActiveModal,
    protected formBuilder: FormBuilder,
    protected productService: ProductService,
    public dateUtilService: DateUtilService
  ) {}

  @Input() data: /* TemplateComponent */ any;
  isAdmin: boolean;

  public form: FormGroup;
  ngOnInit(): void {
    this.applyOnOrder = false;
    this.minInitialDate = this.data.extra.orp.ordberlevdat;
  }
  onSave(): void {
    this.activeModal.close({ data: this.data, applyOnOrder: this.applyOnOrder });
  }

  onCancel(): void {
    this.activeModal.close();
  }

  updateDeliveryDate(row, selectedDeliveryDate) {
    row.extra.orp.ordberlevdat = format(selectedDeliveryDate.date, 'yyyy-MM-dd');
    row.extra.orp.ordberedndat = format(this.dateUtilService.addWorkDays(selectedDeliveryDate.date, 3), 'yyyy-MM-dd');
  }

  public formatNgbDate(date: NgbDate, formatString = 'yyMMdd') {
    const dObj = this.dateUtilService.createDateFromNgbDate(date);
    return format(dObj, formatString);
  }
}
